import React from 'react';
import { useTranslation } from '../i18n';

export default function HotelCard({ hotel, onSelect, onImageClick, imageUrls, imageIndex }) {
  const { t } = useTranslation();
  const imageUrl = hotel.image || hotel.imageUrl || hotel.photo || 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&h=300&fit=crop';
  const price = hotel.price || hotel.rate || hotel.pricePerNight || t('hotel.contactForPricing');
  const rating = hotel.rating || hotel.stars || hotel.starRating || 0;
  const amenities = hotel.amenities || hotel.features || [];

  return (
    <div className="hotel-card">
      <img
        src={imageUrl}
        alt={hotel.name || hotel.hotelName || t('hotel.fallbackName')}
        className="hotel-image hotel-image-clickable"
        onClick={() => onImageClick && onImageClick(imageUrls || [imageUrl], imageIndex || 0)}
      />
      <div className="hotel-info">
        <div className="hotel-name">{hotel.name || hotel.hotelName || t('hotel.fallbackName')}</div>
        <div className="hotel-price">{typeof price === 'number' ? `${t('hotel.currencySymbol')}${price}${t('hotel.perNight')}` : price}</div>
        <div className="hotel-rating">
          {'★'.repeat(Math.floor(rating))}{'☆'.repeat(5 - Math.floor(rating))}
          <span className="hotel-rating-value">{rating}</span>
        </div>
        <div className="hotel-location">
          📍 {hotel.location || hotel.address || hotel.city || t('hotel.locationNotSpecified')}
        </div>
        {amenities && amenities.length > 0 && (
          <div className="hotel-amenities">
            {amenities.slice(0, 4).map((amenity, idx) => (
              <span key={idx} className="amenity-tag">{amenity}</span>
            ))}
            {amenities.length > 4 && (
              <span className="amenity-tag">{t('hotel.more', { n: amenities.length - 4 })}</span>
            )}
          </div>
        )}
        <button className="select-btn" onClick={() => onSelect(hotel)}>
          {t('hotel.select')}
        </button>
      </div>
    </div>
  );
}
